import React, { useState, useEffect } from "react";
import BreadCrumb from "../../BreadCrumb";
import Layout from "../../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../../common/Loader";
import {
  fetchBranchList,
  createBranchName,
  createClassName,
  createClassGroupName,
  fetchBranchClassGroups,
  updateClassGroupFeeAction,
  fetchBranchHierarchy,
  updateClassGroupNameAction,
  updateClassRoomNameAction,
} from "../../../redux/actions/feesActions";
import { useForm, Controller } from "react-hook-form";
import ReactSelect from "react-select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Form, Row, Col, Card, Button, Table } from "react-bootstrap";
import { customFormatOptions } from "../../../common/converters";
import CreateBranch from "./createBranch";
import { BRANCH, CLASS_GROUP, CLASS_NAME } from "../../constants";
import Editable from "react-x-editable";

const FeeSetup = (props) => {
  const dispatch = useDispatch();
  const {
    loader,
    feeDetails,
    branchList,
    branchHierarchyData,
    branchLevelClassGroups,
  } = useSelector((state) => state.fees);
  const [fees, setFees] = useState(feeDetails);
  const [branchData, setBranchData] = useState([]);
  const [show, setShow] = useState(false);
  const [sideMenu, setSideMenu] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState({});
  const onSideMenu = (value) => {
    setSideMenu(value);
  };
  const validationSchema = Yup.object().shape({
    branchName: Yup.string().required("Branch Name is required"),
    playSchool: Yup.string().required("Play School is required"),
    nursery: Yup.string().required("Nursery is required"),
    jrKg: Yup.string().required("Jr.Kg Attend is required"),
    srKg: Yup.string().required("Sr.Kg is required"),
  });
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      taxBenfits: "false",
      // city
    },
    resolver: yupResolver(validationSchema),
  });

  useEffect(async () => {
    await dispatch(fetchBranchList());
    // await dispatch(fetchBranchHierarchy());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(async () => {
    setBranchData(customFormatOptions(branchList, "id", "name"));
  }, [branchList]);

  const createBranch = async (data) => {
    switch (selectedEvent) {
      case BRANCH:
        await dispatch(createBranchName(data));
        await dispatch(fetchBranchList());
        break;
      case CLASS_GROUP:
        await dispatch(createClassGroupName(data));
        break;
      case CLASS_NAME:
        await dispatch(createClassName(data));
        break;

      default:
        break;
    }

    setShow(false);
  };

  const closeModal = () => {
    setShow(false);
  };
  const createClassRoom = async () => {
    setShow(true);
    setSelectedEvent(CLASS_NAME);
  };
  const updateClassGroupFee = async (groupObj, fee) => {
    const multipleValues = getValues(["BranchId"]);
    await dispatch(
      updateClassGroupFeeAction({
        ClassGroupId: groupObj.ClassGroupId,
        BranchId: parseInt(multipleValues[0].value),
        fee,
      })
    );
    await dispatch(
      fetchBranchHierarchy({
        BranchId: parseInt(multipleValues[0].value),
      })
    );
  };
  const updateClassGroupName = async (groupObj, name) => {
    const multipleValues = getValues(["BranchId"]);
    await dispatch(
      updateClassGroupNameAction({
        ClassGroupId: groupObj.ClassGroupId,
        name
      })
    );
    await dispatch(
      fetchBranchHierarchy({
        BranchId: parseInt(multipleValues[0].value),
      })
    );
  };
  const updateClassRoomName = async (groupObj, name) => {
    const multipleValues = getValues(["BranchId"]);
    await dispatch(
      updateClassRoomNameAction({
        ClassRoomId: groupObj.id,
        name
      })
    );
    await dispatch(
      fetchBranchHierarchy({
        BranchId: parseInt(multipleValues[0].value),
      })
    );
  };
  const classGroupAction = async () => {
    setShow(true);
    setSelectedEvent(CLASS_GROUP);
    // await dispatch(fetchClassGroups());
  };
  const onChangeAction = async (data) => {
    setValue("BranchId", data);

    if (data && data.value) {
      setSelectedBranch(data);
      // await dispatch(
      //   fetchBranchClassGroups({
      //     BranchId: data.value,
      //   })
      // );
      await dispatch(
        fetchBranchHierarchy({
          BranchId: data.value,
        })
      );
    }
  };

  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader}>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          <CreateBranch
            show={show}
            closeModal={closeModal}
            create={createBranch}
            selectedEvent={selectedEvent}
            branchData={branchData}
          />
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-10 col-lg-7 col-xl-7"></div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-5 col-xl-5">
              <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-2 col-lg-4 col-xl-4">
                  <Button
                    className="btn app-default-button btn btn-primary"
                    type="button"
                    onClick={() => {
                      setShow(true);
                      setSelectedEvent(BRANCH);
                    }}
                  >
                    Create Branch Name
                  </Button>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <Button
                    className="btn app-default-button btn btn-primary"
                    type="button"
                    onClick={classGroupAction}
                  >
                    Create Branch Group
                  </Button>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-4 col-xl-4">
                  <Button
                    className="btn app-default-button btn btn-primary"
                    type="button"
                    onClick={createClassRoom}
                  >
                    Create Class Room
                  </Button>
                </div>
               
                
              </div>
            </div>
          </div>
          <div className="spacer"></div>
          <Card>
            <Card.Header> Branch Hierarchy </Card.Header>
            <Card.Body>
              <Form noValidate>
                <Form.Group
                  as={Row}
                  className="mb-3 required"
                  controlId="formPlaintextEmail"
                >
                  <Form.Label column sm="2">
                    Select Branch Name
                  </Form.Label>
                  <Col sm="4">
                    <Controller
                      name="BranchId"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <ReactSelect
                            isClearable
                            {...field}
                            options={branchData}
                            className={`${errors.BranchId ? "is-invalid" : ""}`}
                            onChange={onChangeAction}
                          />
                          <span className="invalid-feedback">
                            {errors.BranchId?.message}
                          </span>
                        </>
                      )}
                      {...register("BranchId")}
                    />
                  </Col>
                </Form.Group>
                
                {branchHierarchyData.length > 0 ? (
                  <>
                    <Row>
                      <Col xl={12}>
                        <>
                        <Table responsive className="table table-bordered">
                          {/* <Table responsive className="m-0 data-table-shadow"> */}
                            <thead
                              style={{
                                backgroundColor: "#1c5984",
                                color: "#ffff",
                              }}
                            >
                              <tr>
                                <th
                                  scope="col"
                                  style={{ padding: "10px 0px 10px 0px" }}
                                  className="text-center"
                                >
                                  Class Group
                                </th>
                                <th
                                  scope="col"
                                  style={{ padding: "10px 0px 10px 0px" }}
                                  className="text-center"
                                >
                                  Fee
                                </th>
                                <th
                                  scope="col"
                                  style={{ padding: "10px 0px 10px 0px" }}
                                  className="text-center"
                                >
                                  Class Room Name
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {branchHierarchyData.map(obj=>(
                                <>
                                <tr className="text-center">
                                <td>
                                  {/* {obj.ClassGroup.name} */}
                                  <Editable
                                    type="textfield"
                                    mode="popover"
                                    initialValue={obj.ClassGroup.name}
                                    editText="Edit"
                                    placement="top"
                                    value={obj.ClassGroup.name}
                                    renderConfirmElement={true}
                                    validate={(value) => {
                                      if (!isNaN(value)) {
                                        return "Numbers not allowed";
                                      }
                                      updateClassGroupName(obj, value);
                                    }}
                                    />
                                </td>
                                <td>
                                <Editable
                                    type="textfield"
                                    mode="popover"
                                    initialValue={obj.fee}
                                    editText="Edit"
                                    placement="top"
                                    value={obj.fee}
                                    renderConfirmElement={true}
                                    validate={(value) => {
                                      if (isNaN(value)) {
                                        return "Characters not allowed";
                                      }
                                      updateClassGroupFee(obj, value);
                                    }}
                                    />
                                </td>
                                <td colSpan={obj.branch_classgroup_classroom_info.length}>
                                    {
                                      obj.branch_classgroup_classroom_info.map(childObj=>(
                                        <div className={{paddingRight:"10px"}}>
                                        {/* <td  > */}
                                        <Editable
                                    type="textfield"
                                    mode="popover"
                                    initialValue={childObj.name}
                                    editText="Edit"
                                    placement="top"
                                    value={childObj.name}
                                    renderConfirmElement={true}
                                    validate={(value) => {
                                      if (!isNaN(value)) {
                                        return "Numbers not allowed";
                                      }
                                      updateClassRoomName(childObj, value);
                                    }}
                                    />
                                     &nbsp;&nbsp;&nbsp;
                                          {/* </td>  */}
                                           &nbsp;
                                          </div>
                                      ))
                                    }
                                </td>
                              </tr>
                                </>
                              ))}
                            
                            </tbody>
                          </Table>
                        </>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <div className="alert alert-success">No Data to view</div>
                )}
                
              </Form>
            </Card.Body>
          </Card>
          <div className="spacer"></div>
        </div>
      </PageLoader>
    </div>
  );
};

export default FeeSetup;
